import {alias, createModelSchema, list} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {RewardGeneratorModel} from "@/modules/redactor/models/reward-generator/RewardGeneratorModel";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";

export class CardPackageModel extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._rarity = 0;

        this._guard = new GuardConfig();

        this._cards = [];
        this._generators = [];
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get rarity() {
        return this._rarity;
    }

    set rarity(value) {
        this._rarity = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get cards() {
        return this._cards;
    }

    set cards(value) {
        this._cards = value;
    }

    get generators() {
        return this._generators;
    }

    set generators(value) {
        this._generators = value;
    }

    valid() {

        if (!this.key || this.key.length <= 0) {
            return false;
        }

        if (!this.name || this.name.length <= 0) {
            return false;
        }

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (!Number.isInteger(this.rarity) || this.rarity <= 0 || this.rarity > 6) {
            return false;
        }

        if (this.cards.length <= 0 && this.generators.length <= 0) {
            return false;
        }

        if (this.cards && this.cards.some(v => !v || !RedactorUtils.getCard(v))) {
            return false;
        }

        if (this.generators && this.generators.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return this.cards.length <= 0 && this.generators.length <= 0;
    }

    copy() {
        let value = super.copy();
        value._id = "";
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new CardPackageModel());
        } else if (target instanceof CardPackageModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(CardPackageModel, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _guard: alias("guard", GuardConfig.schema()),
    _rarity: alias("rarity", Schema.primitive()),
    _cards: alias("cards", list(Schema.primitive())),
    _generators: alias("generators", list(RewardGeneratorModel.schema()))
});